import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { saveAddress } from '../utils/storage'
import { isUnlockWithWalletConnect } from '../utils/account'
import { requestSelectedAddress } from '../utils/extensions'
import { setFingerPrint } from '../utils/fingerPrint'
import { setAccount, getAccount } from '../redux/account/action'

export const ChainIds = {
  bscMainnet: 56,
  bscTestnet: 97,
  bbcMainnet: 'Binance-Chain-Tigris',
  bbcTestnet: 'Binance-Chain-Ganges',
  ethMainnet: 1,
  eth2ndMainnet: '0x01',
}

export const getNetworkByChainId = chainId => {
  let network = {
    id: 'bsc-mainnet',
    name: 'Binance Smart Chain Mainnet',
  }
  switch (chainId) {
    case ChainIds.bscMainnet:
      network = {
        id: 'bsc-mainnet',
        name: 'Binance Smart Chain Mainnet',
      }
      break
    case ChainIds.bscTestnet:
      network = {
        id: 'bsc-testnet',
        name: 'Binance Smart Chain Testnet',
      }
      break
    case ChainIds.bbcMainnet:
      network = {
        id: 'bbc-mainnet',
        name: 'Binance Chain Mainnet',
      }
      break
    case ChainIds.bbcTestnet:
      network = {
        id: 'bbc-testnet',
        name: 'Binance Chain Testnet',
      }
      break
    case ChainIds.ethMainnet:
    case ChainIds.eth2ndMainnet:
      network = {
        id: 'eth-mainnet',
        name: 'Ethereum Network',
      }
      break
    default:
      break
  }
  return network
}

// just render on client side
export default Component => {
  return function WrappedComponent(props) {
    const dispatch = useDispatch()
    const { deviceInfo } = useSelector(state => state.globalData)

    useEffect(() => {
      const timer = setTimeout(() => {
        // eslint-disable-next-line
        // @ts-ignore: Object is of type 'unknown'.
        const { BinanceChain } = window
        if (!BinanceChain) return
        if (isUnlockWithWalletConnect()) return

        BinanceChain.on('connect', ({ chainId }) => {
          console.log('BinanceChain connected')
          dispatch(
            setAccount({
              network: getNetworkByChainId(chainId),
            })
          )
        })

        BinanceChain.on('accountsChanged', accounts => {
          console.log('BinanceChain accounts changed. New accounts are ', accounts)
          saveAddress(accounts[0], {
            keystore: 'HARDWARE',
            flags: { isWalletConnect: false, isExtensionWallet: true },
          })
          setFingerPrint(deviceInfo, 'unlock_extension_wallet', accounts[0], '')
          dispatch(getAccount(accounts[0]))
          dispatch(
            setAccount({
              address: accounts[0],
              flags: { isWalletConnect: false, isExtensionWallet: true },
              privateKey: 'HARDWARE',
            })
          )
          window.location.reload()
        })

        BinanceChain.on('chainChanged', async chainId => {
          console.log(
            'BinanceChain chain changed. New chain: ',
            chainId,
            getNetworkByChainId(chainId)
          )
          const address = await requestSelectedAddress()
          saveAddress(address, {
            keystore: 'HARDWARE',
            flags: { isWalletConnect: false, isExtensionWallet: true },
          })
          setFingerPrint(deviceInfo, 'unlock_extension_wallet', address, '')
          dispatch(getAccount(address))
          dispatch(
            setAccount({
              address,
              network: getNetworkByChainId(chainId),
              flags: { isWalletConnect: false, isExtensionWallet: true },
              privateKey: 'HARDWARE',
            })
          )
        })

        BinanceChain.on('disconnect', () => {
          console.log('disconnected from extension wallet ')
        })
      }, 1000)
      return () => clearTimeout(timer)
    }, [dispatch, deviceInfo])

    return <Component {...props} />
  }
}
